function removeAssitant() {
  const menuButton = document.querySelector('.header__primary-nav button');
  if (menuButton) {
    menuButton.addEventListener('click', () => {
      const launcher = document.querySelector('iframe#launcher');
      if (launcher) {
        launcher.classList.add('launcher--z-index-2');
      }
    });
  }
}
removeAssitant();
